import { useEffect, useRef, useState } from "react";
import { StyledIgvDiv } from "./Igv.style";

const updatePath = (path) => path.replace("/var/www/html", "");

export const getTrack = (data) => {
  return {
    format: "bed",
    url: updatePath(`${data?.igvHost}${data?.filePath}`),
    indexed: true,
    indexURL: updatePath(`${data?.igvHost}${data?.indexPath}`),
    name: "gRNA",
    displayMode: "EXPANDED",
    squishedRowHeight: 20,
    order: 1000002,
    autoHeight: true,
    visibilityWindow: 10000000,
    color: function (variant) {
      const gRNA_id = variant.name;
      return getColorBygRNA(gRNA_id);
    },
  };
};
const getColorBygRNA = (gRNA_id) => {
  const selectedRows = sessionStorage.getItem("seletedTableRowKeys")
    ? JSON.parse(sessionStorage.getItem("seletedTableRowKeys"))
    : [];
  return selectedRows.some((key) => key === gRNA_id) ? "#ff2101" : "#000096";
};

const IGV = ({ data }) => {
  const container = useRef(null);
  const [igvCreated, setIGVCreated] = useState(false);
  const [scriptLoad, setScriptLoad] = useState(false);
  const indexName = ["Name", "Sequence", "Transcript", "Score"];

  // load script and call IGV once component mounted
  const createIGV = () => {
    const igvOptions = {
      genome: data?.genome,
      locus: data.locus,
      tracks: [{ ...getTrack(data) }],
      trackDefaults: {
        annotation: {
          autoHeight: false,
          height: 150,
          maxHeight: 300,
          displayMode: "SQUISHED",
        },
      },
    };
    window?.igv?.createBrowser(container.current, igvOptions).then((b) => {
      window.igv.browser = b;
      window.igvCheckboxClicked = (event, info) => {
        const arrInfo = typeof info === "string" ? [info] : info;
        const data = { checked: event.target.checked, gRNA_id: arrInfo };
        const customevent = new CustomEvent("igv-track-checkbox", {
          detail: data,
        });
        document.dispatchEvent(customevent);
      };
      window.selectAllInLocation = (event, location) => {
        const savedLocToSirna = sessionStorage.getItem("loctosirnaids");
        const parsed = savedLocToSirna ? JSON.parse(savedLocToSirna) : null;
        if (parsed) {
          const arrSirnaIds = parsed.filter(
            (item) => item.location === location
          );
          if (arrSirnaIds && arrSirnaIds.length) {
            const savedSirnaIds = arrSirnaIds[0].siraids;
            window.igvCheckboxClicked(event, savedSirnaIds);
          }
        }
      };

      const onTrackClickHandler = (track, popoverData) => {
        const updateTableNew = (arr) => {
          if (typeof arr === "string") {
            const xr = arr.split("#");
            sirdIdsToMap.push(xr[0]); // add SIRNA ID
            xr.forEach((it, i) => {
              if (indexName[i] === "Name") return false;
              div_content += `<div class="table-row"><div class="table-col">${indexName[i]}</div>
                 <div class="table-col">${it} </div></div>`;
            });
          } else {
            if (arr.key === "Location") {
              locSirnaList.push({ location: arr.value, siraids: sirdIdsToMap });
              var locCheckBox = "";
              sirdIdsToMap = [];
              sessionStorage.setItem(
                "loctosirnaids",
                JSON.stringify(locSirnaList)
              );
              div_loc += `<div class="loc-wrapper">
                <div class="loc-data table-row"><div class="table-col">${locCheckBox}${arr.key}</div>
                <div class="table-col">${arr.value}</div>
                </div>${div_content}</div>`;
              div_content = "";
            }
          }
        };

        const addCheckboxNew = (data, i) => {
          const info =
            typeof data === "string"
              ? data.split("#")
              : data.filter((it) => it.key === "Name");
          const siraid = info && info.length ? info[0]?.value || info[0] : null;
          const selectedRows = sessionStorage.getItem("seletedTableRowKeys")
            ? JSON.parse(sessionStorage.getItem("seletedTableRowKeys"))
            : [];
          const checked = selectedRows.some((key) => key === siraid);
          const checkedAttr = checked ? "checked" : "";
          let hrrule = "";
          if (i !== 0) {
            hrrule = "<hr/>";
          }
          if (siraid) {
            const refSeq =
              idData && idData.length
                ? "<span>" + siraid + " - " + idData + "</span>"
                : '<input type="checkbox" ' +
                  checkedAttr +
                  " onclick=\"igvCheckboxClicked(event, '" +
                  siraid +
                  "')\"/> <span>[ " +
                  siraid +
                  " ]</span>";
            return (
              hrrule +
              '<div class="checkbox-data table-row"><div class="table-col full">' +
              refSeq +
              "</div></div>"
            );
          }
        };

        // Don't show a pop-over when there's no data.
        if (!popoverData || !popoverData.length) {
          return false;
        }

        let t = [];
        var maxTrackCount = 0;
        // variables for rendering in div

        var div_markup = '<div class="popup-window">';
        var div_content = "";
        var div_loc = "";
        var sirdIdsToMap = [];
        var locSirnaList = [];
        // store ID value for later use
        var idData = popoverData
          .filter((f) => f.name === "Id")
          .map((m) => m.value);

        // rendering in div instead of table
        popoverData.forEach(function ({ name, value }) {
          if (!name && t.length) {
          } else {
            if (name === "Name") {
              const nameSplit = value.split("|");
              maxTrackCount =
                nameSplit.length > maxTrackCount
                  ? nameSplit.length
                  : maxTrackCount;
              nameSplit.forEach((n, i) => {
                div_content += addCheckboxNew(n, i);
                updateTableNew(n, t);
              });
            } else {
              updateTableNew({ key: name, value: value }, t);
            }
          }
        });
        const divClose = div_loc ? "</div>" : "";
        div_markup += div_loc + div_content + divClose + "</div>";
        return div_markup;
      };
      b.on("trackclick", function (track, popoverData) {
        sessionStorage.removeItem("loctosirnaids");
        sessionStorage.setItem("trackclickdata", JSON.stringify(popoverData));
        return onTrackClickHandler(track, popoverData);
      });
    });
  };

  useEffect(() => {
    if (scriptLoad && data && data.igvHost && data.genome && !igvCreated) {
      createIGV();
      setIGVCreated(true);
    }
  }, [data, scriptLoad, igvCreated]);

  useEffect(() => {
    const curC = container.current;
    const scriptTag = document.createElement("script");
    scriptTag.src = "static/igv.min-latest.js";
    scriptTag.addEventListener("load", () => setScriptLoad(true));
    document.body.appendChild(scriptTag);
    return () => {
      curC?.firstChild?.remove();
    };
  }, []);

  return <StyledIgvDiv id="igv-div" ref={container} />;
};

export default IGV;
